module.exports = __webpack_public_path__ + "static/media/edit.ff9a0950.svg";